import { action, makeObservable, observable } from 'mobx';

export class ThemeService {
  @observable isDark = false;

  constructor() {
    makeObservable(this);
    const saved = localStorage.getItem('theme');
    if (saved) {
      this.isDark = saved === 'dark';
    } else {
      this.isDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
    }
    this._applyTheme();
  }

  @action.bound
  toggle(): void {
    this.isDark = !this.isDark;
    localStorage.setItem('theme', this.isDark ? 'dark' : 'light');
    this._applyTheme();
  }

  private _applyTheme(): void {
    document.documentElement.setAttribute('data-theme', this.isDark ? 'dark' : 'light');
  }
}

export const themeService = new ThemeService();
